import { render, staticRenderFns } from "./Logs.vue?vue&type=template&id=bfe1c56c"
import script from "./Logs.vue?vue&type=script&lang=js"
export * from "./Logs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports